import colors from 'vuetify/lib/util/colors';

const theme_colors = [
  {
    name: 'Blue-light',
    scheme: 'md-blue-500-scheme',
    dark: false,
    primary: colors.blue.base,
    secondary: colors.blue.lighten4, // #FFCDD2
    accent: colors.blue.accent2, // #3F51B5
  },
  {
    name: 'Yellow-light',
    scheme: 'md-amber-a700-scheme',
    dark: true,
    primary: colors.amber.darken1,
    secondary: colors.amber.lighten4, // #FFCDD2
    accent: colors.amber.accent2, // #3F51B5
  },
  {
    name: 'Red-light',
    scheme: 'md-red-a400-scheme',
    dark: true,
    primary: colors.red.accent3,
    secondary: colors.red.lighten4, // #FFCDD2
    accent: colors.red.accent2, // #3F51B5
  },
  {
    name: 'Pink-light',
    dark: false,
    scheme: 'md-pink-a100-scheme',
    primary: colors.pink.accent1,
    secondary: colors.pink.lighten4, // #FFCDD2
    accent: colors.pink.accent2, // #3F51B5
  },
  {
    name: 'Purple-light',
    dark: false,
    scheme: 'md-purple-a700-scheme',
    primary: colors.purple.accent4,
    secondary: colors.purple.lighten4, // #FFCDD2
    accent: colors.purple.accent2, // #3F51B5
  },
  {
    name: 'DeepPurple-light',
    dark: false,
    scheme: 'md-deep-purple-a700-scheme',
    primary: colors.deepPurple.base,
    secondary: colors.deepPurple.lighten4, // #FFCDD2
    accent: colors.deepPurple.accent2, // #3F51B5
  }
];

const navi_colors = [
  {
    name: 'black',
    class: 'black'
  },
  {
    name: 'red-pink',
    class: 'gradient-red-pink'
  },
  {
    name: 'blue-grey-blue',
    class: 'gradient-blue-grey-blue'
  },
  {
    name: 'green-teal',
    class: 'gradient-green-teal'
  },
  {
    name: 'purple-deep-purple',
    class: 'gradient-purple-deep-purple'
  },
  {
    name: 'purple-amber',
    class: 'gradient-purple-amber'
  },
  {
    name: 'indigo-purple',
    class: 'gradient-indigo-purple'
  },
  {
    name: 'deep-purple-blue',
    class: 'gradient-deep-purple-blue'
  },
  {
    name: 'deep-orange-orange',
    class: 'gradient-deep-orange-orange'
  },
  {
    name: 'light-blue-cyan',
    class: 'gradient-light-blue-cyan'
  },
  {
    name: 'timber',
    class: 'gradient-timber'
  },
  {
    name: 'strawberry',
    class: 'gradient-strawberry'
  },
  {
    name: 'orange',
    class: 'gradient-orange'
  },
  {
    name: 'pomegranate',
    class: 'gradient-pomegranate'
  },
  {
    name: 'green-tea',
    class: 'gradient-green-tea'
  },
  {
    name: 'blackberry',
    class: 'gradient-blackberry'
  },
  {
    name: 'plum',
    class: 'gradient-plum'
  },
  {
    name: 'passion-fruit',
    class: 'gradient-passion-fruit'
  },
  {
    name: 'sublime-vivid',
    class: 'gradient-sublime-vivid'
  },
  {
    name: 'summer',
    class: 'gradient-summer'
  },
  {
    name: 'crystal-clear',
    class: 'gradient-crystal-clear'
  },
  {
    name: 'dawn',
    class: 'gradient-dawn'
  },
  {
    name: 'grapefruit-sunset',
    class: 'gradient-grapefruit-sunset'
  },
  {
    name: 'man-of-steel',
    class: 'gradient-man-of-steel'
  }
]

export default { theme_colors, navi_colors }
